import * as angular from "angular";
import {IController} from "angular";

export class confirmOrderSummeryDialog implements IController {
  public orderPrice: any;
  public currency: any;

  public onSubmit: Function;
  public onCancel: Function;

  $onInit() {
    this.currency = this.orderPrice.currencyCode;
  }
}

angular
  .module('bringoz.admin.orders')
  .component('confirmOrderSummeryDialog', {
    bindings: {
      orderPrice: '<',
      onSubmit: '&',
      onCancel: '&'
    },
    template: require('./confirm-order-summery-dialog.html').default,
    controller: confirmOrderSummeryDialog
  });
